import { InjectionToken } from '@angular/core';
import { CleverPushPlatform } from '../entities/clever-push.entity';

export interface CleverPushEnvironmentConfig {
  channelIdWeb: string;
  channelIdMobile: string;
  platform: CleverPushPlatform;
  notificationServiceUrl: string;
  priceAlertServiceUrl: string;
}

export const CLEVER_PUSH_ENVIRONMENT_CONFIG = new InjectionToken<CleverPushEnvironmentConfig>('CleverPushEnvironmentConfig');
